import React, { useState } from 'react'
import { ReactComponent as Phone } from '../assets/images/phone-fill.svg'
import { ReactComponent as Mail } from '../assets/images/mail-fill.svg'
import { Link } from 'react-router-dom'
import { API_BASE_URL } from '../utils/apiConfig';

const faqData = [
  { question: 'What services do you offer?', answer: 'We offer a wide range of digital solutions including web development, mobile apps, UI/UX design, and custom software tailored to your business needs.' },
  { question: 'How can I get started with a project?', answer: 'You can get started by contacting us through our form or reaching out via email. We’ll schedule a discovery call to understand your goals and guide you through the next steps.' },
  { question: 'What is your pricing model?', answer: 'Our pricing depends on the project scope and complexity. We offer both fixed-price packages and hourly engagement models after understanding your requirements.' },
  { question: 'Do you offer ongoing support?', answer: 'Yes, we provide maintenance and support plans to ensure your product stays updated, secure, and continues to perform well.' },
];

const Contact = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    projecttype: '',
    budget: '',
    message: ''
  });

  const [status, setStatus] = useState(null); // ✅ notification message
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const sendMes = `Name: ${formData.name}\nEmail: ${formData.email}\nProject Type: ${formData.projecttype}\nProject Budget: ${formData.budget}\nMessage: ${formData.message}`;

    const sendData = {
      email: formData.email,
      message: sendMes
    };

    try {
      const res = await fetch(`${API_BASE_URL}/sendmail/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sendData)
      });

      if (!res.ok) throw new Error("Failed to submit form");

      setStatus({ type: "success", message: "✅ Message sent successfully!" });

      // reset form
      setFormData({ name: '', email: '', projecttype: '', budget: '', message: '' });

      // auto-hide message
      setTimeout(() => setStatus(null), 3000);

    } catch (err) {
      setStatus({ type: "error", message: "❌ Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>SEND A MESSAGE</h2>

          <div className="form-grid">
            <input type="text" name="name" placeholder="Your Name *" value={formData.name} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Your Email *" value={formData.email} onChange={handleChange} required />
            <input type="text" name="projecttype" placeholder="What you are interested *" value={formData.projecttype} onChange={handleChange} required />
            <input type="text" name="budget" placeholder="Project Budget *" value={formData.budget} onChange={handleChange} required />
          </div>

          <textarea placeholder="Message *" name="message" value={formData.message} onChange={handleChange} required></textarea>

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>

          {/* ✅ Notification below the form */}
          {status && (
            <p
              className={`status-message ${status.type}`}
              style={{ marginTop: "10px", fontWeight: "bold", color: status.type === "success" ? "green" : "red" }}
            >
              {status.message}
            </p>
          )}
        </form>

        <div className="get-in-touch">
          <span className='text-left-line'>Contact</span>
          <h2 className='base_heading'>Let's Drive Your <span className="highlight">Growth Together</span></h2>
          <p className="base_p_tag">
            Have an idea or project in mind? Let's bring it to life. Reach out to us - we're here to collaborate, create, and build solutions that fuel your growth.
          </p>
        </div>
      </div>

      <div>
        <div className="contact-info">
          <div className="contact-info-outer-div">
            <div className="contact-info-div">
              <Phone /> 
              <p className='base_p_tag'>Call Us</p>
              <Link to={'tel:+919884873316'}>+919884873316</Link>
            </div>
            <div className="contact-info-div">
              <Mail />
              <p className='base_p_tag'>Mail Us</p>
              <Link to={'mailto:sales@infiniese.com'}>sales@infiniese.com</Link>
            </div>
          </div>
        </div>

        <div className="faq-container">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <div className="faq-list">
            {faqData.map((item, index) => (
              <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                <button className="faq-question" onClick={() => toggleFAQ(index)}>
                  {item.question}
                  <span>{activeIndex === index ? '-' : '+'}</span>
                </button>
                <div className={`faq-answer-wrapper ${activeIndex === index ? 'open' : ''}`}>
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact;
